import React from 'react';
import { PanelLeftIcon, Sun, Moon } from 'lucide-react';

export function Topbar({ isOpen = true, onToggle, onToggleTheme }: { isOpen?: boolean; onToggle?: () => void; onToggleTheme?: () => void }) {
  return (
    <header className="flex items-center justify-between px-6 py-4 border-b bg-neutral-800 text-neutral-100">
      <div className="flex items-center gap-3">
        <button
          onClick={onToggle}
          className="p-2 rounded-md hover:bg-neutral-700"
          title="Toggle sidebar"
          data-testid="button-sidebar-toggle"
        >
          <PanelLeftIcon className="w-5 h-5" />
        </button>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={onToggleTheme}
          className="p-2 rounded-md hover:bg-neutral-700"
          title="Toggle theme"
          data-testid="button-theme-toggle"
        >
          <Sun className="w-5 h-5" />
          <Moon className="w-5 h-5 hidden" />
        </button>
      </div>
    </header>
  );
}

export default Topbar;
